import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardContent,
  CardActions,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableHead,
  TableRow,
  Typography,
  Divider
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end'
  },
  margin: {
    margin: `${theme.spacing(1)}px 0`
  },
  archived: {
    backgroundColor: "#D0D0D0"
  },
  unarchived: {
  }
}));

function Results({
  results,
  handleChangePage,
  handleChangeRowsPerPage,
  headers,
  cells,
  className,
  noPagination,
  ...rest
}) {
  const classes = useStyles();

  if (!results)
    return (
      <Card {...rest} className={className}>
        <CardContent>
          <Typography variant="h4">No results</Typography>
          <Divider className={classes.margin} />
          <Typography variant="subtitle1">
            There is nothing to show. Try creating some data.
          </Typography>
        </CardContent>
      </Card>
    );

  return (
    <Card {...rest} className={className}>
      <Table>
        <TableHead>
          <TableRow>
            {headers &&
              headers.map((header, i) => (
                <TableCell key={i}>{header}</TableCell>
              ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {results.edges &&
            results.edges.map(result => (
              <TableRow className={result.archived ? classes.archived : classes.unarchived} key={result.uuid ? result.uuid : result.id}>
                {cells &&
                  cells.map((cell, i) => (
                    <TableCell key={i}>
                      {cell.component
                        ? cell.component(result)
                        : result[cell.field]}
                    </TableCell>
                  ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
      {!noPagination && (
        <CardActions className={classes.actions}>
          <TablePagination
            component="div"
            count={results.pageInfo && results.pageInfo.total}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={
              results.pageInfo &&
              Math.ceil(results.pageInfo.offset / results.pageInfo.limit)
            }
            rowsPerPage={results.pageInfo && results.pageInfo.limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      )}
    </Card>
  );
}

Results.propTypes = {
  results: PropTypes.exact({
    edges: PropTypes.array,
    pageInfo: PropTypes.exact({
      total: PropTypes.number,
      offset: PropTypes.number,
      limit: PropTypes.number,
      given: PropTypes.number,
      __typename: PropTypes.string
    }),
    __typename: PropTypes.string
  }),
  className: PropTypes.string,
  headers: PropTypes.array,
  cells: PropTypes.array,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func
};

export default Results;
